import React from "react";
import Icon from "../../dashboard/Icon/Icon";
import { calculateProgress } from "../../utils/helper";
import "./singlecounter.css";
import Title from "../ReusableComponents/Title/Title";

const SingleCounterPreview = ({ configData = {} }) => {
  const { config = {} } = configData;
  const { setThresholds, count, maxCount, name, icon } = config;
  const color = calculateProgress(configData).color;
  const iconImgName = icon?.imgName || "lsq_copy";

  return (
    <div className="single-counter">
      <div className="content overflow-ellipsis">
        <div className="count-content">
          {setThresholds && (
            <span
              className="threshold-color"
              role="threshold-color"
              style={{ backgroundColor: color }}
            ></span>
          )}
          <span className="ng_h_2_b">{count}</span>
          {count > -1 && maxCount > -1 && (
            <span className=" total-count ng_h_5_m">
              {maxCount ? `/${maxCount}` : ""}
            </span>
          )}
        </div>
        <Title text={name || "Tasks"}/>
      </div>
      <Icon src={`images/${iconImgName}.svg`} alt="icon" />
    </div>
  );
};

export default SingleCounterPreview;
